import React, { Component } from 'react';
import classnames from 'classnames';
import { SketchPicker } from 'react-color'
import { calculateRatio } from '../../../../lib/wcagValidator';

import Preview from '../Preview';

import './index.scss';

class BrandPersonalization extends Component {
  
    constructor(props){
      super(props);
      this.setWrapperRef = this.setWrapperRef.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.state ={
        errormessage:'Uploaded image is of not right type or dimentions',
        actioncolor:'',
        showActionpallet:false,
        showBrandpallet:false,
      }
    }
    
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
      }
    
      /**
       * Alert if clicked on outside of element
       */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showActionpallet:false,
                showBrandpallet:false,
            })
        }
      }


    fileUpload = () =>{
        const file = this.fileUploadImage.files[0];
        this.props.onSave(file,'logo');
        console.log(file);
    }
    actioncolorchange = (event) =>{
        console.log(event);
        this.setState({
            actioncolor:event.hex
        })
    }
    togglePallets=(pallet)=>{
        this.setState({
            [pallet]:!this.state[pallet]
        })
    }
    brandColorDescriptionText=(domain)=>{
        if(domain==='DENTAL'){
            return 'Use a color that stands out on your website and has good contrast with a white icon. This color is used for buttons and links associated with the Web Chat.';
        }else{
            return 'Use a brand color that has good contrast with white text. This color is used for chat window header and as a background color.';
        }
    }
    backgroundColorDescriptionText=(domain)=>{
            return 'Use a color that has good contrast with white text. This color is used for the chat window header and visitor chat bubble.';
    }
    validateSave =()=>{
        const { props } = this.props;
        const { business_name, assistant_name, actioncolor, brandcolor } = props;
        console.log('Brand Values',business_name , assistant_name , actioncolor , brandcolor)
        if(business_name && assistant_name && actioncolor && brandcolor){
            if(business_name.trim().length>0 && assistant_name.trim().length>0 && actioncolor.trim().length>0 && brandcolor.trim().length>0 ){
                return false;
            }else{
                return true;
            }
        }else{
            return true;
        }
    }
    getFirstCharecter=(business_name)=>{
        if(business_name && business_name.length>0){
            return business_name.charAt(0)
        }
        return 'T'

    }
    render(){
        const { props, onValueChange, onSave, onCancel, removeLogo, webchatconfig, auth ,business} = this.props;
        const { global_logo_file, business_name, assistant_name, actioncolor, brandcolor, greetings } = props;
        const { showActionpallet, showBrandpallet } = this.state;
        const { domain_keywords, domain } = auth;
      return (<div className="design">
                <div className="brand_config">
                    <div className="logo">
                        <div className="title">Logo</div>
                        <div className="description">Upload .jpg or .png image. Maximum size: 500KB. Recommended dimensions: 100x100 pixels
                        </div>
                        <div className="upload">
                            <div className="image-container">
                            {global_logo_file?(<img src={global_logo_file}/>):(<div>{this.getFirstCharecter(business_name)}</div>)}
                            </div>
                            <div className="action-buttons">
                              <input ref={(ref) => this.fileUploadImage = ref} 
                                    onChange = {this.fileUpload}
                                      accept="image/*" 
                                      type="file" 
                                      enctype="multipart/form-data" 
                                      className="form-group" />
                              <button className="button upload"><i className="material-icons">cloud_upload</i><span>Upload your logo</span></button>
                            </div>
                            <div className="action-buttons">
                                <button className="button remove" onClick={removeLogo}>Remove</button>
                            </div>
                        </div>
                        {webchatconfig && webchatconfig.logoSizeerror&& <div className="errormessage">{this.state.errormessage}</div>}
                    </div>
                    <div className="logo">
                        <div className="title">{domain_keywords.DOMAIN_SYNONYM} Name</div>
                        <div className="description">This name will appear at the top of the chat window.</div>
                        <div className="input-conatiner">
                            <input className="input" onChange = {(e)=>onValueChange(e,'business_name')} value={business_name}></input>
                        </div>
                    </div>
                    <div className="logo">
                        <div className="title">Assistant name</div>
                        <div className="description">Customize the name to give assistant personality.</div>
                        <div className="input-conatiner">
                            <input className="input" onChange = {(e)=>onValueChange(e,'assistant_name')} value={assistant_name}></input>
                        </div>
                    </div>
                    <div className="logo">
                        <div className="title">Brand color</div>
                        <div className="description">{this.brandColorDescriptionText(domain)}</div>
                        <div className="color-conatiner">
                            <div className="pallet" style={{backgroundColor:actioncolor}} onClick={()=>this.togglePallets('showActionpallet')}></div> <input className="input" value={actioncolor} onChange={(e)=>{onValueChange(e,'actioncolor'); onValueChange(e,'brandcolor')}} disabled={true}></input>
                        </div>
                        {showActionpallet &&
                        <div className="colr-picker" ref={this.setWrapperRef}>
                        <SketchPicker 
                            color={ actioncolor }
                            onChangeComplete={ (e)=>{onValueChange(e,'actioncolor'); onValueChange(e,'brandcolor')} }
                        />
                        </div>
                        }
                        <div className="wcag-ratio" style={{backgroundColor: calculateRatio(actioncolor,'#FFFFFF')<0.22222? '#e7f1e5':'#f4e7eb'}}>
                           <div className="wcag-ratio_value" style={{color: calculateRatio(actioncolor,'#FFFFFF')<0.22222 ?'#46474D': '#eb5d72'}}>Contrast Ratio : {calculateRatio(actioncolor,'#FFFFFF').toFixed(2)} </div> 
                           <div className="wcag-ratio_description">{calculateRatio(actioncolor,'#FFFFFF')<0.22222?"This color passes WCAG standards for color accessibility.":
                           "This color doesn't passes WCAG standards for color accessibility. Choose darker color that has good contrast with white text."}</div> 
                           
                        </div>
                    </div>
                    
                    <div className="actions">
                      <button type="button" className="btn btn--primary btn--md first-button" onClick={(e)=>onSave(e,'brandings')} disabled={this.validateSave()}>
                          SAVE
                      </button>
                      <button type="button" className="btn btn--link button-cancel" onClick={onCancel} >
                          Cancel
                      </button>
                  </div>
                </div>
                <Preview logo={global_logo_file} auth={auth} business_name={business_name} assistant_name={assistant_name} actioncolor={actioncolor} brandcolor={brandcolor} message={greetings} usermessage/>
              </div>)
    }
};

export default BrandPersonalization;
